import ReactDOM from 'react-dom/client'
import '@progress/kendo-theme-default/dist/all.css';
import './index.css'
import AppWrapper from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as Element)
root.render(
  <AppWrapper />
)
